<template>
  <div class="login-page">
    <div class="login-page__content" style="width: 100%">
      <div class="login-page__inner">
        <div class="login-inner">
          <div class="d-flex justify-content-center mb-5">
            <Logo />
          </div>

          <div class="login-inner__nav mb-4">
            <div class="login-inner__nav-item">
              <div class="login-title" style="color: #004680;">Войти по ИНН Вашего предприятия</div>

              <div class="login-hr"></div>
            </div>
          </div>

          <div>
            <ui-input-box-floating class="mb-3" :error="errors.inn">
              <ui-input v-model="inn" placeholder="E-mail" type="E-mail" />
              <ui-input-label>ИНН</ui-input-label>
            </ui-input-box-floating>

            <ui-button class="btn-base btn-large">Войти</ui-button>
          </div>

          <div class="login-inner__nav mb-4">
            <div
              @click="() => (loginEcp = true)"
              class="login-inner__nav-item"
            >
              <div class="login-title" style="color: #004680;">Вход по ЭЦП</div>

              <div class="login-hr"></div>
            </div>
          </div>

          <div>
            <div class="login-alert p-3 text-center mb-3">
              <div class="text-primary">Внимание!</div>
              <span>Вставьте ключ ЭЦП и выберите тип ключа</span>
            </div>

            <EcpButton
              @auth="getCertificatesObject"
              :loading="loadingLogin"
              :loginType="loginType"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Logo from "@/assets/svg/LogoLogin.vue";

import { ref, onMounted } from "vue";

import EcpButton from "../../component/ecp/Button.vue";

const loginEcp = ref(false);
const errors = ref([]);
const inn = ref(null);
</script>